"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_dates_1 = require("react-dates");
const moment_1 = __importDefault(require("moment"));
// Theme overrides.
require("./theme");
const selectPastDays = (day) => !react_dates_1.isInclusivelyBeforeDay(day, moment_1.default.utc());
const selectAllDays = () => false;
exports.DateRangePicker = props => {
    const { startDate, endDate, onDatesChange, selectableDates = "all", hideKeyboardShortcutsPanel = true } = props;
    const [focusedInput, setFocusedInput] = react_1.useState(null);
    const isOutsideRange = selectableDates === "all"
        ? selectAllDays
        : selectableDates === "past"
            ? selectPastDays
            : undefined;
    return (react_1.default.createElement(react_dates_1.DateRangePicker, Object.assign({ startDate: startDate, startDateId: "start", endDate: endDate, endDateId: "end", onDatesChange: onDatesChange, focusedInput: focusedInput, onFocusChange: setFocusedInput, 
        // Defaults set by MicroscopeKit.
        hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel, isOutsideRange: isOutsideRange }, props)));
};
exports.DateRangePicker.displayName = "DateRangePicker";
